import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { MemberType } from 'api/models';
import { TeamsBulkUpdateStatus } from 'api/teams';
import { Loading } from 'components/atoms/loading';
import { StyledAvatar } from 'components/molecules/placeholder-avatar';
import { useTeamDetail } from 'hooks/placeholders/use-team-detail';

const Wrapper = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  max-width: 70%;
`;

const Description = styled.div`
  font-size: var(--font-size-base);
  font-weight: var(--heading-3-weight);
  color: var(--gray-70);
  margin-top: var(--spacing-03);
`;

const PlaceHolderContainer = styled.div`
  font-size: var(--font-size-base);
  margin-top: var(--spacing-05);
`;

const PlaceHolderItem = styled.div`
  display: flex;
  align-items: center;
  margin: var(--spacing-05) 0;
`;

type ErrorModalPropsType = {
  updateStatuses?: TeamsBulkUpdateStatus[];
};

const ErrorModal = (props: ErrorModalPropsType) => {
  const { updateStatuses } = props;

  const { isTeamsLoading, getTeamById } = useTeamDetail();

  if (
    !updateStatuses ||
    !updateStatuses[0]?.responseMeta?.response?.response?.teams
  ) {
    return <></>;
  }

  const errorTeamList = updateStatuses[0].responseMeta.response.response.teams;

  return (
    <Wrapper>
      <Description>
        <FormattedMessage id="projects.placeholders.update.failed.description" />
      </Description>
      {isTeamsLoading ? (
        <Loading />
      ) : (
        <PlaceHolderContainer>
          {errorTeamList.slice(0, 3).map((info) => {
            const { team, status } = info;
            const teamDetails = getTeamById(team.teamId);

            if (!teamDetails || status) {
              return null;
            }

            return (
              <PlaceHolderItem>
                <StyledAvatar
                  name={teamDetails?.teamName}
                  size={20}
                  isCustomerRole={teamDetails?.teamType === MemberType.External}
                  isPlaceholder
                />
                &nbsp;{teamDetails?.teamName}
              </PlaceHolderItem>
            );
          })}
          {errorTeamList.length > 3 && (
            <PlaceHolderItem>
              <StyledAvatar
                name={(errorTeamList.length - 3).toString()}
                size={20}
                isCustomerRole={false}
                isPlaceholder
              />
              &nbsp;{(errorTeamList.length - 3).toString()}
              &nbsp;
              <FormattedMessage id="others" />
            </PlaceHolderItem>
          )}
        </PlaceHolderContainer>
      )}
    </Wrapper>
  );
};

export { ErrorModal };
